import { render } from "./EditMerchantModal.vue?vue&type=template&id=333af066&scoped=true"
import script from "./EditMerchantModal.vue?vue&type=script&lang=js"
export * from "./EditMerchantModal.vue?vue&type=script&lang=js"

import "./EditMerchantModal.vue?vue&type=style&index=0&id=333af066&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-333af066"]])

export default __exports__